var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"tiptap-btn",attrs:{"type":"button","title":_vm.$t('Clear formatting'),"disabled":_vm.disabled},on:{"click":function($event){_vm.editor.chain().focus().clearNodes().unsetAllMarks().run()}}},[_c('FormatClearIcon',{attrs:{"size":"16"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }